// entry.client.js
import createApp from './src/app.js';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  app.$mount('#app');
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultDescript =
    "Looking for GB WhatsApp APK New Version Download? It's a modified version of the official app. Download GBWhatsApp app to enjoy extra features."
  const defaultKeyword = 'GB WhatsApp, GB WhatsApp APK'
  const title = meta.title || 'GB WhatsApp APK New Version Download v18.80 Updated 2026'
  document.title = title
  const defaultCanonical = 'https://gbofficial.net/'



  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('og:title', title);
  setMetaTag('title', title);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag('icon', '/gbwa-logo.webp', { type: 'image/webp' });
  setLinkTag('canonical', meta.link?.find(link => link.rel === 'canonical')?.href || defaultCanonical);

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    // 如果不是 noindex 页面，确保 robots 标签是默认的
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href, attrs = {}) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
  Object.keys(attrs).forEach((key) => {
    element.setAttribute(key, attrs[key]);
  });
}
